export default "__VITE_ASSET__CWubp1WW__"